<template>
  <div>
    <!-- <CRow v-if="isAuthenticated === true">
      <CCol md="12">
        <CCard>
          <CCardHeader>
            Overview
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol lg="3" md="4">
                <CIcon name="cil-user" height="60"/>
                <CCallout color="info">
                  <small class="text-muted">Username</small><br>
                  <strong class="h4">{{user.username}}</strong>
                </CCallout>
              </CCol>
              <CCol lg="3" md="4">
                <CIcon name="icon-enterprise" height="60"/>
                <CCallout color="success">
                  <small class="text-muted">Workspaces</small><br>
                  <strong class="h4">2</strong>
                </CCallout>
              </CCol>
              <CCol lg="3" md="4">
                <CIcon name="icon-project" height="60"/>
                <CCallout color="warning">
                  <small class="text-muted">Projects</small><br>
                  <strong class="h4">3</strong>
                </CCallout>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow> -->
    <!-- <CRow v-else> -->
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <h4>MHESI for EV Survey (Round 1)</h4>            
            <!-- <div class="card-header-actions">
              <a 
                href="https://coreui.io/vue/docs/3.2/"
                class="card-header-action" 
                rel="noreferrer noopener" 
                target="_blank"
              >
                <small class="text-muted">docs</small>
              </a>
            </div> -->
          </CCardHeader>
          <CCardBody>
            <!-- <h5> &emsp; {{contents}} </h5> -->
            <h5>
              &emsp; ระบบสำรวจข้อมูลการใช้รถไฟฟ้าของหน่วยงานในสังกัด อว. ภายใต้โครงการพัฒนาแพลตฟอร์ม Coordinating and Managing Entity (CME) 
              สำหรับการบริหารจัดการคาร์บอนจากการใช้ยานยนต์ไฟฟ้าร่วมกับการจัดทำกรณีศึกษาในพื้นที่นำร่อง (ระยะที่ 1)
            </h5>
            <!-- <CCButtonBadge
              :notificationCount="3"
            >
              abc
            </CCButtonBadge> -->
            
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { axiosInstance } from '@/api'
// import { CForm } from '@coreui/vue';
// import MainChartExample from './charts/MainChartExample'
// import WidgetsDropdown from './widgets/WidgetsDropdown'
// import WidgetsBrand from './widgets/WidgetsBrand'

import CCNumber from '@/vue/base/CCNumber.vue'
import CCButtonBadge from '@/vue//base/CCButtonBadge.vue';

export default {
  name: 'Home',
  components: {
    // MainChartExample,
    // WidgetsDropdown,
    // WidgetsBrand
    // CCNumber,
    // CCButtonBadge,
  },
  data () {
    return {
      brand: undefined,
      // tableItems: [
      //   {
      //     avatar: { url: 'img/avatars/1.jpg', status: 'success' },
      //     user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'USA', flag: 'cif-us' },
      //     usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Mastercard', icon: 'cib-cc-mastercard' },
      //     activity: '10 sec ago'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/2.jpg', status: 'danger' },
      //     user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2015' },
      //     country: { name: 'Brazil', flag: 'cif-br' },
      //     usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Visa', icon: 'cib-cc-visa' },
      //     activity: '5 minutes ago'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/3.jpg', status: 'warning' },
      //     user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'India', flag: 'cif-in' },
      //     usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Stripe', icon: 'cib-stripe' },
      //     activity: '1 hour ago'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/4.jpg', status: '' },
      //     user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'France', flag: 'cif-fr' },
      //     usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'PayPal', icon: 'cib-paypal' },
      //     activity: 'Last month'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/5.jpg', status: 'success' },
      //     user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'Spain', flag: 'cif-es' },
      //     usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Google Wallet', icon: 'cib-google-pay' },
      //     activity: 'Last week'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/6.jpg', status: 'danger' },
      //     user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'Poland', flag: 'cif-pl' },
      //     usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Amex', icon: 'cib-cc-amex' },
      //     activity: 'Last week'
      //   }
      // ],
      // tableFields: [
      //   { key: 'avatar', label: '', _classes: 'text-center' },
      //   { key: 'user' },
      //   { key: 'country', _classes: 'text-center' },
      //   { key: 'usage' },
      //   { key: 'payment', label: 'Payment method', _classes: 'text-center' },
      //   { key: 'activity' },
      // ],
      // selected: 'Month',
      contents: 'ระบบสำรวจข้อมูล EV',
      projects: [],
      workspaces: []
    }
  },
  mounted() {
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    isAuthenticated () {
      return this.$store.state.isAuthenticated
    },
    isSuspended () {
      return this.$store.state.user.isSuspended
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
  .c-icon {
    fill: #4e696d;
  }
  // Set position: relative & adjust position to relate with Icon
  .c-callout {
    top: -65px;
    left: 76px;
  }
</style>